import { VENUE_ADDRESS_TYPE_IDS } from './venue-address-type-ids.js';
function rank(candidate) {
    const typeRank = VENUE_ADDRESS_TYPE_IDS.indexOf(candidate.typeId);
    return typeRank * 2 + (candidate.defaultFlag ? 0 : 1);
}
/** Default Shipping, any Shipping, default Main Office, then any Main Office; earlier input wins ties. */
export function pickVenueAddress(candidates) {
    let best = null;
    for (const candidate of candidates) {
        if (!VENUE_ADDRESS_TYPE_IDS.includes(candidate.typeId))
            continue;
        if (best === null || rank(candidate) < rank(best))
            best = candidate;
    }
    return best;
}
//# sourceMappingURL=pick-venue-address.js.map